import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import SettingsReducer from "./slices/settings";
import TimelineStagesReducer from "./slices/timelineStages";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const settingsPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
  whitelist: [
    "currency",
    "symbol",
    "mode",
    "language",
    "user",
    "isAuthenticated",
  ],
};
const rootReducer = combineReducers({
  settings: persistReducer(settingsPersistConfig, SettingsReducer),
  timelineStages: TimelineStagesReducer,
});

export { rootPersistConfig, rootReducer };
